// GENERATED BY scripts/ap-process-svg DO NOT EDIT
import { GeneratedIcon } from './Icon'
import type { GeneratedIconProps } from './Icon/types'
import Svg from './svg/icon-close.svg?react'

export const IconClose = (props: GeneratedIconProps) => (
  <GeneratedIcon {...props}>
    <Svg preserveAspectRatio="xMidYMid meet" />
  </GeneratedIcon>
)

IconClose.displayName = 'IconClose'
